import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class GlobalState
{
	private data = new Subject<object>();
	private dataStream = this.data.asObservable();
	private subscriptions: Map<string, ((param: number) => void)[]> = new Map<string, ((param: number) => void)[]>();

	constructor()
	{
		this.dataStream.subscribe((data) => this.onEvent(data));
	}

	notifyDataChanged(event: string, value: number | boolean)
	{
		const current = this.data[event];
		if (current !== value)
		{
			this.data[event] = value;

			this.data.next({
				event: event,
				data: this.data[event]
			});
		}
	}

	subscribe(event: string, callback: (param: number | boolean) => void)
	{
		const subscribers = this.subscriptions.get(event) || [];
		subscribers.push(callback);
		this.subscriptions.set(event, subscribers);
	}

	onEvent(data: object)
	{
		const subscribers = this.subscriptions.get(data['event']) || [];
		subscribers.forEach((callback) =>
		{
			callback.call(null, data['data']);
		});
	}
}
